// extracted by mini-css-extract-plugin
export default {"Greeting":"AskAicaGreeting_Greeting__tmGLJ","greetingIn":"AskAicaGreeting_greetingIn__ma9WQ","greetingGradientDrift":"AskAicaGreeting_greetingGradientDrift__5Oeul"};